import CurrentReportTypes from '../action-types/current-report';

// eslint-disable-next-line import/prefer-default-export
export const setCurrentReportData = reportId => ({
    type: CurrentReportTypes.SET_CURRENT_REPORT_DATA,
    payload: { reportId },
});
